/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 26/7/2021
 * @Example
 */


import React, { useEffect, useState, useRef } from 'react';
import { Dropdown, Button, Modal, ModalHeader, ModalBody } from 'diginet-core-ui/components';
import Config from '../../../../config/index';
import { useDispatch } from 'react-redux';
import * as W06F0008Actions from '../../../../redux/W0X/W06F0008/W06F0008_actions';
import { browserHistory } from 'react-router';

const ModalW06F0008 = (props) => {
    const { onClose } = props;
    const dispatch = useDispatch();
    const [ContractNo, setContractNo] = useState('');
    const [error, setError] = useState(false);
    const [cbContract, setCbContract] = useState([]);
    const item = useRef(null);

    useEffect(() => {
        getPopupContract();
        /* eslint-disable */
    }, [])

    const getPopupContract = () => {
        dispatch(W06F0008Actions.getPopupContract(null, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            setCbContract(data);
        }))
    }

    const onSave = () => {
        if (!ContractNo) {
            setError(true);
            return false;
        }
        browserHistory.push({
            pathname: Config.getRootPath() + 'W06F0009',
            state: {
                ...item.current,
                mode: 'add'
            }
        });
    }

    return (
        <div>
            <Modal
                open={true}
                onClose={onClose}
                width={'50%'}
            >
                <ModalHeader title={Config.lang("Chon_hop_dong_lap_phu_luc")} />
                <ModalBody>
                    <Dropdown
                        label={Config.lang("Chon_hop_dong")}
                        dataSource={cbContract}
                        onChange={e => {
                            setContractNo(e.value);
                            setError(false);
                            item.current = e.data;
                        }}
                        valueExpr={"ContractID"}
                        displayExpr={"ContractDes"}
                        required
                        error={error}
                        value={ContractNo}
                        viewType="outlined"
                    />
                    <div className="text-center pull-right">
                        <Button viewType="filled" color='info' label={Config.lang("Dong_y")} onClick={onSave} />
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default ModalW06F0008;